<script lang="ts">
	import Select from 'svelte-select';
	import Button from '../../Button.svelte';

	export let interestOne: { value: any; label: string };
	export let interestTwo: { value: any; label: string };
	export let options = [];
	export let operator: string;

	const toggleOperator = (event: Event, newOperator: string) => {
		event.preventDefault();
		operator = newOperator;
	};

	const dispatchChangeOne = (interest: { value: any; label: string }) => {
		interestOne = interest;
	};

	const dispatchChangeTwo = (interest: { value: any; label: string }) => {
		interestTwo = interest;
	};

	$: finalOptions = options.map((option) => {
		return { value: option.id, label: option.name };
	});
</script>

<span style="width: 150px;">
	<Select
		selectedValue={interestOne}
		items={finalOptions}
		on:select={(e) => {
			dispatchChangeOne(e.detail);
		}}
		on:clear={() => {
			interestOne = { value: '', label: '' };
		}}
	/>
</span>
<div>
	<Button
		margin
		variant={operator === 'AND' ? 'raised' : 'outlined'}
		on:click={(e) => toggleOperator(e, 'AND')}
	>
		AND
	</Button>
	<Button
		margin
		variant={operator === 'OR' ? 'raised' : 'outlined'}
		on:click={(e) => toggleOperator(e, 'OR')}
	>
		OR
	</Button>
</div>
<span style="width: 150px;">
	<Select
		selectedValue={interestTwo}
		items={finalOptions}
		on:select={(e) => {
			dispatchChangeTwo(e.detail);
		}}
		on:clear={() => {
			interestTwo = { value: '', label: '' };
		}}
	/>
</span>

<style>
	div {
		display: flex;
		justify-content: center;
		padding: 14px 12px;
	}

	:global(.inner-select) {
		min-width: 250px;
	}
</style>
